import React from "react";
import { Card } from "react-bootstrap";
import ImageDate from "../../assets/日曆.png";
import ImageTime from "../../assets/時鐘.png";
import ImagePoint from "../../assets/選單.png";
import "./reservCard.css";

const ReservCard = (props) => {
  const date = new Date(props.date);
  const dayOfWeek = date.getDay();
  const days = [
    "星期日",
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六",
  ];

  return (
    <Card
      style={{ width: "100%", maxWidth: "400px"}}
      className="mx-auto mt-1 rounded-5 shadow"
    >
      <Card.Header
        className="text-start rounded-top-5"
        style={{ backgroundColor: "#56ACAE", color: "white" }}
      >
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <p className="h3 m-1">
              <b>保養預約</b>
            </p>
          </div>

          <div style={{ right: "0" }} onClick={props.handleClick}>
            <img src={ImagePoint} alt="Date" className="fixed-aspect-image" />
          </div>
        </div>
      </Card.Header>
      <Card.Body>
        <Card.Text>
          <div className="d-flex flex-column my-1">
            <div className="row text-center">
              {/* 日期部分 */}
              <div className="col-7 d-flex align-items-center justify-content-center">
                {/* 日期圖 */}
                <img
                  src={ImageDate}
                  alt="Date"
                  style={{ width: "18px", marginRight: "4px" }}
                />
                <div className="d-flex flex-column justify-content-center align-items-start">
                  {/* 日期 */}
                  <p className="m-0">
                    <b className="reservCard-date">
                      {props.date.replace(/-/g, "/")}
                    </b>
                  </p>
                  {/* 星期 */}
                  <p className="m-0 reservCard-week">
                    <b>{days[dayOfWeek]}</b>
                  </p>
                </div>
              </div>

              {/* time */}
              <div className="col-5 d-flex align-items-center justify-content-center">
                {/* 時間圖 */}
                <img
                  src={ImageTime}
                  alt="Time"
                  style={{ width: "18px", marginRight: "4px" }}
                />
                {/* 時間 */}
                <p className="m-0 reservCard-time">
                  <b>{props.time}</b>
                </p>
              </div>
            </div>
            <hr className="reservCard-hr mx-auto"></hr>
            <div className="m-0">
              <div className="d-flex flex-column align-items-start reservCard-words ms-4 mb-0">
                <p className="m-0">
                  <b style={{ color: "#56ACAE" }}>機器名稱</b>
                </p>
                <p className="m-0 ">
                  <b>{props.type}</b>
                </p>
              </div>
            </div>
            <hr className="reservCard-hr mx-auto"></hr>
            <div className="m-0">
              <div className="d-flex flex-column align-items-start reservCard-words ms-4 mb-0">
                <p className="m-0">
                  <b>{props.clinicName}</b>
                </p>
                <p className="m-0 reserdCard-location">
                  <b>{props.location}</b>
                </p>
              </div>
            </div>
          </div>
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

export default ReservCard;
